export class DashboardControllerHtml {
    contrllerskin () {
        return `
            <div class="container-layout d-grid grid-2">
                <div class="container-column grow-col-2">
                    <div class="column-header">
                    <div class="header-title has-icon">
                        <span class="iconify" data-icon="mingcute:performance-line"></span>
                        <h3>Circuit</h3>
                        <div class="header-actions">
                            <button class="full-screen-button" title="Full Screen">
                                <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                            </button>
                        </div>
                    </div>
                    </div>
                    <div class="container-body">
                        <div class="table-responsive">
                            <table class="has-min-width">
                            <thead>
                                <tr>
                                <th colspan="2"></th>
                                <th>BLOCK 1</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="has-icon">INV 01</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                                <tr>
                                    <td class="has-icon">INV 02</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                                <tr>
                                    <td class="has-icon">INV 03</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                                <tr>
                                    <td class="has-icon">INV 04</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                                <tr>
                                    <td class="has-icon">INV 05</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                                <tr>
                                    <td class="has-icon">INV 06</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                                <tr>
                                    <td class="has-icon">INV 07</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                                <tr>
                                    <td class="has-icon">INV 08</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                                <tr>
                                    <td class="has-icon">MVT</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                                <tr>
                                    <td class="has-icon">GEN 1</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                                <tr>
                                    <td class="has-icon">GEN 2</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                                <tr>
                                    <td class="has-icon">GEN 3</td>
                                    <td class="text-right"></td>
                                    <td class="text-right bg-danger"></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="container-column ">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <span class="iconify" data-icon="mingcute:performance-line"></span>
                            <h3>PPC</h3>
                            <div class="header-actions">
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="table-responsive">
                            <table class="has-min-width">
                                <tbody>
                                    <tr>
                                        <td>PPC</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>MTR1</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>MTR2</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="container-column">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <span class="iconify" data-icon="mingcute:performance-line"></span>
                            <h3>Substation Solar</h3>
                            <div class="header-actions">
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="table-responsive">
                            <table class="has-min-width">
                                <tbody>
                                    <tr>
                                        <td>Solar Line 1</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Solar Line 2</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Solar Line 3</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Solar Line 4</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Solar Line 5</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Solar Line 6</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Solar Line 7</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Solar Line 8</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Solar Line 9</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Solar Line 10</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Solar Line 11</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="container-column">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <span class="iconify" data-icon="mingcute:performance-line"></span>
                            <h3>Substation BESS</h3>
                            <div class="header-actions">
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="table-responsive">
                            <table class="has-min-width">
                                <tbody>
                                    <tr>
                                        <td>BESS Line 1</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>BESS Line 2</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>BESS Line 3</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>BESS Line 4</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>BESS Line 5</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>BESS Line 6</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>BESS Line 7</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>BESS Line 8</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="container-column">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <span class="iconify" data-icon="mingcute:performance-line"></span>
                            <h3>Substation Generator</h3>
                            <div class="header-actions">
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="table-responsive">
                            <table class="has-min-width">
                                <tbody>
                                    <tr>
                                        <td>Generator Line 1</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Generator Line 2</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Generator Line 3</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Generator Line 4</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                    <tr>
                                        <td>Generator Line 5</td>
                                        <td class="w-100 text-right"></td>
                                        <td class="text-right w-100 bg-danger"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}